<template>
  <transition name="fade">
    <div class="new-event">
      <div class="form-card">
        <h1 class="form-title">Create Event</h1>
        <p class="form-subtitle">Set up a new scheduling event for your team</p>

        <form @submit.prevent="submitHandler" class="event-form">
          <div class="form-group">
            <label for="event-name" class="form-label">Event Name</label>
            <input
              id="event-name"
              data-test="eventname"
              type="text"
              v-model="name"
              placeholder="Team Sync Meeting"
              class="form-input"
              :class="{ 'input-error': error.name }"
            />
            <p v-if="error.name" class="form-error">{{ error.name }}</p>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="sdate" class="form-label">Start Date</label>
              <input
                type="date"
                name="sdate"
                id="sdate"
                v-model="sdate"
                class="form-input"
                :class="{ 'input-error': error.sdate }"
              />
              <p v-if="error.sdate" class="form-error">{{ error.sdate }}</p>
            </div>

            <div class="form-group">
              <label for="edate" class="form-label">End Date</label>
              <input
                type="date"
                name="edate"
                id="edate"
                v-model="edate"
                class="form-input"
                :class="{ 'input-error': error.edate }"
              />
              <p v-if="error.edate" class="form-error">{{ error.edate }}</p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="stime" class="form-label">Start Time</label>
              <input
                type="time"
                name="stime"
                id="stime"
                v-model="stime"
                class="form-input"
                :class="{ 'input-error': error.stime }"
              />
              <p v-if="error.stime" class="form-error">{{ error.stime }}</p>
            </div>

            <div class="form-group">
              <label for="etime" class="form-label">End Time</label>
              <input
                type="time"
                name="etime"
                id="etime"
                v-model="etime"
                class="form-input"
                :class="{ 'input-error': error.etime }"
              />
              <p v-if="error.etime" class="form-error">{{ error.etime }}</p>
            </div>
          </div>

          <button type="submit" class="btn btn-primary btn-submit">
            Create Event
          </button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { instance } from "../api";

export default {
  data() {
    return {
      name: "",
      sdate: "",
      edate: "",
      stime: "09:00",
      etime: "17:00",
      error: {
        name: "",
        sdate: "",
        edate: "",
        stime: "",
        etime: "",
      },
    };
  },
  mounted() {
    // Set default timings
    let a = new Date();
    const appendZero = (num) => {
      if (String(num).length === 1) {
        return "0" + num;
      }
      return num;
    };
    this.sdate = `${a.getFullYear()}-${appendZero(a.getMonth())}-${appendZero(
      a.getDate()
    )}`;
    a.setDate(a.getDate() + 5);
    this.edate = `${a.getFullYear()}-${appendZero(a.getMonth())}-${appendZero(
      a.getDate()
    )}`;
  },
  methods: {
    async submitHandler() {
      // TODO form validation 1. ensure date and time are far away 2. ensure event name is not empty
      // convert datetime
      let eventID;

      const eventDetails = {
        event_name: this.name,
        start_date: this.sdate,
        end_date: this.edate,
        start_time: this.stime,
        end_time: this.etime,
      };
      const formValidation = this.validateForm();
      if (!formValidation) {
        return;
      }
      const postResponse = await instance.post("/add", eventDetails);
      eventID = postResponse.data;

      this.clearForm();

      // redirect user
      // backend endpoint to create new event and get event id
      this.$router.push({ name: "event", params: { id: eventID } });
    },
    validateForm() {
      // validate blanks
      let formStatus = true;
      if (this.name.length === 0) {
        this.error.name = "Event name cannot be empty";
        formStatus = false;
      }
      if (!this.sdate) {
        this.error.sdate = "Start date cannot be empty";
        formStatus = false;
      }
      if (!this.edate) {
        this.error.edate = "End date cannot be empty";
        formStatus = false;
      }
      if (!this.stime) {
        this.error.stime = "Start time cannot be empty";
        formStatus = false;
      }
      if (!this.etime) {
        this.error.etime = "End time cannot be empty";
        formStatus = false;
      }

      // start date cannot be before end date
      const startDate = new Date(this.sdate).getTime();
      const endDate = new Date(this.edate).getTime();
      if (startDate > endDate) {
        this.error.edate = "Start date later than end date";
        formStatus = false;
      }
      // start time cannot be before end time
      if (this.etime.split(":")[0] - this.stime.split(":")[0] < 0) {
        formStatus = false;
        this.error.etime = "Start time later than end time";
      }
      return formStatus;
    },
    clearForm() {
      this.name = "";
      this.sdate = "";
      this.edate = "";
      this.stime = "";
      this.etime = "";
    },
  },
};
</script>

<style scoped>
.new-event {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 3rem 0;
  min-height: calc(100vh - 200px);
}

.form-card {
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.form-title {
  font-size: 2rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.form-subtitle {
  font-size: 0.95rem;
  color: #737373;
  margin-bottom: 2rem;
}

.event-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.input-error {
  border-color: #dc2626 !important;
}

.btn-submit {
  margin-top: 1rem;
  width: 100%;
  padding: 0.875rem;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .new-event {
    padding: 2rem 0;
  }

  .form-card {
    padding: 2rem 1.5rem;
    border-radius: 12px;
  }

  .form-title {
    font-size: 1.75rem;
  }

  .form-subtitle {
    font-size: 0.9rem;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
